import { useEffect, useState } from "react";
import type { AdminUserRow } from "../types";

interface Props {
  user: AdminUserRow;
  onSaved: (note: string) => void;
}

/** Nota interna (CRM-lite) do admin/sysadmin sobre uma conta - nunca vista pela própria pessoa. */
export function AdminNoteEditor({ user, onSaved }: Props) {
  const [draft, setDraft] = useState(user.adminNote);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setDraft(user.adminNote);
    setSaved(false);
  }, [user.id, user.adminNote]);

  const save = async () => {
    setSaving(true);
    setSaved(false);
    try {
      await fetch(`/api/admin/users/${encodeURIComponent(user.id)}/note`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: draft }),
      });
      onSaved(draft);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-block">
      <h3>Anotações internas</h3>
      <p className="admin-user-meta" style={{ marginBottom: 8 }}>
        Visível só pra admins/sysadmin - a própria pessoa nunca vê isto.
      </p>
      <textarea
        className="admin-note-textarea"
        value={draft}
        onChange={(e) => {
          setDraft(e.target.value);
          setSaved(false);
        }}
        placeholder="Ex.: contatada em 10/09 sobre atraso no pagamento…"
        rows={3}
      />
      <button type="button" className="btn-approve" disabled={saving || draft === user.adminNote} onClick={() => void save()}>
        {saving ? "Salvando…" : saved ? "Salvo!" : "Salvar nota"}
      </button>
    </div>
  );
}
